import { useCallback, useEffect, useState } from "react";
import { Bot } from "lucide-react";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "../ui/card";
import { AIAgentSetup } from "./AIAgentSetup";
import { getAgentStatus } from "../../lib/aiAgent";

/**
 * Card "Assistente AI" in Impostazioni.
 * La configurazione vera sta in `AIAgentSetup`, condivisa con la chat del
 * Program Builder: due form separati sarebbero divergiti al primo cambiamento.
 */
export function AIAgentSettingsCard() {
	const [status, setStatus] = useState(null);

	const refresh = useCallback(async () => {
		try {
			setStatus(await getAgentStatus());
		} catch {
			setStatus({ byok_available: false, configured: false });
		}
	}, []);

	useEffect(() => {
		refresh();
	}, [refresh]);

	if (!status) return null;

	return (
		<Card
			className="bg-card border-border rounded-sm"
			data-testid="ai-agent-settings"
		>
			<CardHeader>
				<CardTitle className="font-heading text-xl flex items-center gap-2">
					<Bot className="w-5 h-5 text-volt" />
					Assistente AI
				</CardTitle>
				<CardDescription>
					Scegli il motore AI che preferisci e collega il tuo account. La
					configurazione è personale: nessuno condivide chiavi né consumi.
				</CardDescription>
			</CardHeader>
			<CardContent>
				<AIAgentSetup status={status} onChanged={refresh} />
			</CardContent>
		</Card>
	);
}
